
export function obterValorAnalise(analise: any, pontos: any[]) {
    
    if (analise?.cod_analises?.[0]?.valor === undefined) {
        console.log("undefined");
        return analise?.valor_analise?.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
        });
    }
    
    //CALCULAR VALOR DA ANÁLISE * QUANTIADDE DE PONTOS
    return (analise?.cod_analises?.[0]?.valor * (pontos??[]).length ).toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
    })

}